import { Helmet } from "react-helmet";

import "./styles/WatchCoursePage.style.css";
import { useEffect } from "react";
import AxiosClient from "../../client/AxiosClient";
import { API_GET_QUIZZ_RESULT } from "../../ApiEndPoints";
import { useState } from "react";
import Loader from "../../component/Loader";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import {
  FilledPrimaryBtn,
  FilledPrimaryBtnLink,
} from "../../component/FilledBtn";
import RawHTML from "../../component/RawHTML";

export default function QuizzResultPage() {
  const [loading, setLoading] = useState(true);
  const [resultData, setResultData] = useState(null);
  const [quesAns, setQuesAns] = useState([]);
  const [quizz, setQuizz] = useState(null);

  const params = useParams();
  const quizz_id = params.quizz_id;
  const course_id = params.course_id;
  const result_id = params.result_id;
  const completed_lesson_id = params.completed_lesson_id;

  /* useEffect(() => {
    AxiosClient.post(API_GET_QUIZZ_RESULT + quizz_id, {
      course_id: course_id,
    })
      .then((response) => {
        let data = response.data;

        if (data.success == true) {
          setResultData(data.data);
          setQuesAns(data.data.questions);
          setQuizz(data.data.quiz);

          setLoading(false);
        }
      })
      .catch(() => {})
      .finally(() => {});
  }, []); */

  useEffect(() => {
    AxiosClient.get(API_GET_QUIZZ_RESULT + result_id, {
      params: {
        course_id,
        completed_lesson_id,
      },
    })
      .then((response) => {
        let data = response.data;

        if (data.success == true) {
          setResultData(data.data);
          setQuesAns(data.data.questions);
          setQuizz(data.data.quiz);

          setLoading(false);
        }
      })
      .catch(() => {})
      .finally(() => {});
  }, []);

  function convertMinutesToMinSec(totalMinutes) {
    const minutes = Math.floor(totalMinutes);
    const seconds = Math.round((totalMinutes - minutes) * 60);
    // return { minutes, seconds };
    return `${minutes} Min. ${seconds} sec.`;
  }

  return (
    <main>
      <Helmet>
        <title>Quizz result | {process.env.REACT_APP_NAME}</title>
        <meta
          name="keywords"
          content="online law courses, online law courses in india, law courses in india, management course, law course, civil services, finance course, cyber security course, earn free certificate, online job oriented courses, best online law courses, best online law courses in india"
        />
        <meta
          name="description"
          content="Take online management and law courses from top institution. Learn about business law to advance your education and career with IALM Academy Today!"
        />
      </Helmet>

      <section className="py-0">
        {/* header starts */}

        <div className="watch-course-header bg-lightaccent py-2">
          <div className="container">
            <div class="row align-items-center">
              <div className="col-12 col-md-8">
                <h5 className="mb-0">
                  {quizz == null ? <Loader /> : quizz.title.en}
                </h5>
              </div>
              <div className="col-12 col-md-4 ">
                <div className="course-progress text-center d-flex align-items-center w-100">
                  <div>
                    {loading && (
                      <span className="badge bg-info p-2">Loading</span>
                    )}

                    {resultData && resultData.pass === 0 && (
                      <span className="badge bg-danger p-2 badge-sm">
                        FAILED {resultData?.percentage}
                      </span>
                    )}

                    {resultData && resultData.pass === 1 && (
                      <span className="badge bg-success p-2">
                        PASS {resultData?.percentage}
                      </span>
                    )}

                    <span className="ms-1 lead fw-500">
                      {resultData?.duration
                        ? convertMinutesToMinSec(resultData.duration)
                        : "-"}{" "}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* header ends */}
      </section>
      <section>
        <div className="container">
          {quesAns?.map((item, index) => {
            return (
              <div className="card my-4 rounded-1" key={`ans-${index}`}>
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <h5 className="card-title d-flex">
                      <strong>{index + 1}: </strong>
                      <RawHTML rawHTML={item.qus} />
                    </h5>
                    <h6 className="card-subtitle mb-2 text-muted">
                      {/* {item.isWrong == true ? (
                        <span className="badge badge-danger bg-danger float-end mx-2">
                          Wrong
                        </span>
                      ) : (
                        <span className="badge badge-success bg-success float-end mx-2">
                          Correct
                        </span>
                      )} */}
                    </h6>
                    <SubmissionStatus item={item} />
                  </div>
                  <p className="card-text mt-3">
                    <ol>
                      {item.option.length > 0 &&
                        item.option.map((option, index) => {
                          return (
                            <li className="mb-3">
                              {option.type == "text" ? (
                                <TextOption
                                  text={option.title}
                                  isRight={option.right}
                                />
                              ) : (
                                <ImageOption
                                  src={option.title}
                                  isRight={option.right}
                                />
                              )}{" "}
                              {/* {option.right ? (
                                <FontAwesomeIcon
                                  icon={faCheck}
                                  color="#0056d2"
                                  fontSize={20}
                                />
                              ) : null} */}
                            </li>
                          );
                        })}
                    </ol>
                  </p>
                </div>
              </div>
            );
          })}

          {/* final result */}

          {resultData?.final_result && (
            <Result result={resultData.final_result} />
          )}

          <div className="text-center">
            {resultData != null && resultData.course && (
              <FilledPrimaryBtnLink
                label={"Back to course"}
                link={`/my-courses/watch/${resultData.course.slug}`}
              />
            )}
          </div>
        </div>
      </section>
    </main>
  );
}

function SubmissionStatus({ item }) {
  console.log("item: ", item);

  if (!item.isSubmit) {
    return (
      <span
        className="badge badge-info bg-info float-end mx-2 fw-400 fs-5 ms-auto"
        title="Not submitted"
      >
        {item.obtain_mark} Mark
      </span>
    );
  }

  if (item.isWrong == true) {
    return (
      <span
        className="badge badge-danger bg-danger float-end mx-2 fw-400 fs-5 ms-auto"
        title="Inorrect"
      >
        {item.obtain_mark} Mark
      </span>
    );
  } else {
    return (
      <span
        className="badge badge-success bg-success float-end mx-2 fw-400 fs-5 ms-auto"
        title="Correct"
      >
        {item.obtain_mark} Mark
      </span>
    );
  }
}

function Result({ result }) {
  return (
    <div className="text-center my-5">
      <p className="display-4">
        Total Marks: {result.marks}/{result.exam_marks}
      </p>

      <div class="d-flex justify-content-center">
        <span
          className="badge badge-danger bg-success float-end mx-2 fw-400 fs-5"
          title="Correct Marks"
        >
          {result.positive_marks} Marks
        </span>
        <span
          className="badge badge-danger bg-danger float-end mx-2 fw-400 fs-5"
          title="Incorrect Marks"
        >
          {result.negative_marks} Marks
        </span>
      </div>
    </div>
  );
}

// function MultipleChoiceOptions({
//   choices,
//   handleSaveAnswers,
//   answers,
//   currentQuestionIndex,
// }) {
//   const ans = [];

//   const options = [];

//   return (
//     <div className="multiple-choice-options-wrap">
//       {options.map((item, index) => {
//         return (
//           <label
//             className="d-block"
//             htmlFor={`multiple-form-${index}`}
//             key={`multiple-choice-${index}`}
//           >
//             <input
//               type="checkbox"
//               className="form-check-input"
//               onChange={() => {
//                 handleSaveAnswers();
//               }}
//               value={item.id}
//               checked={item.id === answers[currentQuestionIndex] ? true : false}
//             />

//           </label>
//         );
//       })}
//     </div>
//   );
// }

function TextOption({ text, isRight }) {
  return (
    <>
      <span className="">{text}</span>
      {isRight ? (
        <FontAwesomeIcon
          className="ms-2"
          icon={faCheck}
          color="#0056d2"
          fontSize={20}
        />
      ) : null}
    </>
  );
}
function ImageOption({ src, isRight }) {
  const base_url = process.env.REACT_APP_SERVER_BASE_URL;

  return (
    <div className="card">
      <div class="card-body">
        <img
          alt="Image option"
          src={base_url + src}
          className="img-fuild option-img"
        />

        {isRight ? (
          <span className="ms-2">
            <FontAwesomeIcon icon={faCheck} color="#0056d2" fontSize={30} />
          </span>
        ) : null}
      </div>
    </div>
  );
}
